import React from 'react';
import { Figure } from 'react-bootstrap';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { BlockQuotes, Footer, H5, P } from '../../../../AbstractElements';
import { Adda, AlignmentCenter, BlockcardText, BlockcardText1, BlockcardText2, Blockquotes, cite, Namingasource, Someonefamousin, SourceTitle } from '../../../../Constant';

const BlockQuoteCard = () => {
  return (
    <Col sm='12'>
      <Card>
        <CardHeader className='pb-0'>
          <H5>{Blockquotes}</H5>
          <span>
            {Adda} <code>&lt;{BlockcardText}&gt;</code> {BlockcardText1} <code>&lt;{cite}&gt;</code>.
          </span>
        </CardHeader>
        <CardBody>
          <P className='sub-title'>{Namingasource}</P>
          <Figure className='d-block'>
            <BlockQuotes className='blockquote'>
              <P className='mb-0'>{BlockcardText2}</P>
            </BlockQuotes>
            <Footer className='blockquote-footer'>
              {Someonefamousin}
              <cite title='Source Title'>{SourceTitle}</cite>
            </Footer>
          </Figure>
          <P className='sub-title'>{AlignmentCenter}</P>
          <Figure className='text-center d-block'>
            <BlockQuotes className='blockquote'>
              <P className='mb-0'>{BlockcardText2}</P>
            </BlockQuotes>
            <Footer className='blockquote-footer'>
              {Someonefamousin}
              <cite title='Source Title'>{SourceTitle}</cite>
            </Footer>
          </Figure>
          <P className='sub-title'>{'Alignment Right'}</P>
          <Figure className='d-block text-end'>
            <BlockQuotes className='blockquote'>
              <P className='mb-0'>{BlockcardText2}</P>
            </BlockQuotes>
            <Footer className='blockquote-footer'>
              {Someonefamousin}
              <cite title='Source Title'>{SourceTitle}</cite>
            </Footer>
          </Figure>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BlockQuoteCard;
